module.exports = __webpack_public_path__ + "img/30x30_turuncu.ae3f21a8.gif";